import styled from "@emotion/styled";
import { ReactComponent as AddEditMeter } from "assets/images/addEdit.svg";
import { ReactComponent as PreviewDocuments } from "assets/images/svg/preview-documents-icon.svg";
import { ReactComponent as TechnicalSanctionDocumentIcon } from "assets/images/svg/view-technical-sanction-document.svg";
import { ReactComponent as DemandEstimationDocumentIcon } from "assets/images/svg/view-demand0estimation-document.svg";

export const PreviewPendingDocumentsIcon = styled(PreviewDocuments)(
  ({ theme }) => `
    fill: ${theme.palette.primary.main};
    height: 18px;
    width: 18px;
`
);

export const ViewTechnicalSanctionDocumentIcon = styled(
  TechnicalSanctionDocumentIcon
)(
  ({ theme }) => `
    fill: ${theme.palette.primary.main};
    height: 18px;
    width: 18px;
`
);

export const ViewDemandEstimationDocumentIcon = styled(
  DemandEstimationDocumentIcon
)(
  ({ theme }) => `
    fill: ${theme.palette.primary.main};
    height: 18px;
    width: 18px;
`
);

export const AddEditMeterIcon = styled(AddEditMeter)(
  ({ theme }) => `
    fill: ${theme.palette.primary.main};
    height: 18px;
    width: 18px;
`
);
